import { createAsyncThunk } from "@reduxjs/toolkit";
import { changeBugReportStatus, fetchBugReports } from "./bugReportsApi";

export const fetchBugReportsThunk = createAsyncThunk(
    "reports/fetchAll",
    async (_, { rejectWithValue, signal }) => {
        try {
            const data = await fetchBugReports(signal);
            return data;
        } catch (error) {
            console.error("Error in thunk:", error);
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);

export const changeBugReportStatusThunk = createAsyncThunk(
    "reports/changeStatus",
    async ({ reportId, status }, { rejectWithValue }) => {
        try {
            const response = await changeBugReportStatus(reportId, status);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data || "Error toggling single product");
        }
    }
);